// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/.pnpm/react@18.3.1/node_modules/react/index.js");
__webpack_require__("./node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js");
var __webpack_exports__ = __webpack_require__("./node_modules/.pnpm/core-js@3.39.0/node_modules/core-js/index.js");
